import React from 'react';
import './Home.scss';
import SectionHero from '../../Components/Mersa/SectionHero/SectionHero';
import SectionAbout from '../../Components/Mersa/SectionAbout/SectionAbout';
import SectionServe from '../../Components/Mersa/SectionServe/SectionServe';
import SectionServices from '../../Components/Mersa/SectionServices/SectionServices';
import SectionOurTools from '../../Components/Mersa/SectionOurTools/SectionOurTools';
import SectionOurWork from '../../Components/Mersa/SectionOurWork/SectionOurWork';
import SayAboutUse from '../../Components/Mersa/SayAboutUse/SayAboutUse';
import ContactUs from '../../Components/Mersa/ContactUs/ContactUs';
import { dataListViw } from '../../Data/Data';
import { getHomeList } from '../../Network/home';
import { useQuery } from '@tanstack/react-query';
const Home = ({ t }) => {
  // const data = dataListViw(t)?.slice(0, 4);
  const { data: dataHome, isLoading } = useQuery({
    queryKey: ['getHomeList'],
    queryFn: () => getHomeList(),
  });
  // console.log(dataHome);
  return (
    <div className="home">
      <SectionHero t={t} />
      <SectionAbout t={t} />
      <SectionServe
        t={t}
        data={dataHome?.data?.industries}
        isLoading={isLoading}
      />
      <div
        style={{
          paddingTop: '100px',
        }}
      >
        <SectionServices
          t={t}
          titleBtn={t.Howwework}
          data={dataHome?.data?.services}
          isLoading={isLoading}
        />
      </div>
      <div className="section-our">
        <SectionOurTools
          t={t}
          data={dataHome?.data?.partners}
          isLoading={isLoading}
        />
        <SectionOurWork
          t={t}
          slider={true}
          data={dataHome?.data?.projects}
          isLoading={isLoading}
        />
        {/* <SayAboutUse
          t={t}
          data={dataHome?.data?.testimonials}
          isLoading={isLoading}
        /> */}
      </div>
      <ContactUs t={t} />
    </div>
  );
};

export default Home;
